import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
 const state={   //要设置的全局访问的state对象
     token: '',
     token_type: '',
     menulist:'',
     authlist:'',
     topmenu:'',
     leftmenu:'',
     adminid:'',
     username:'',//后台账号
     role_id:'',
     role_name:'',
     mobilepwd:'',
     enterpriseName:"",
     utypeid:"",//绑定的小程序账户id
     miniUsername:"",//员工姓名
     avatars:"",//员工头像
     lastLoginTime:"",//最后登录时间
     //要设置的初始属性值
   };
const getters = {   //实时监听state值的变化(最新状态)
    getmenulist(state) {  //承载变化的showFooter的值
       return state.menulist
    },
    gettoken(state){  //承载变化的changebleNum的值
       return state.token
    }
};
const mutations = {
    settoken(state,token) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
        state.token = token;
    },
    settoken_type(state,token_type) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
        state.token_type = token_type;
    },
    setmenulist(state,menulist) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
        state.menulist = menulist;
    },
    setauthlist(state,authlist) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
        state.authlist = authlist;
    },
    settopmenu(state,topmenu) {  //同上
        state.topmenu = topmenu;
    },
    setleftmenu(state,leftmenu) {  //同上
        state.leftmenu = leftmenu;
    },
    newNum(state,sum){ //同上，这里面的参数除了state之外还传了需要增加的值sum
       state.changableNum+=sum;
    },
    newAdminid(state,adminid){ //同上，这里面的参数除了state之外还传了需要增加的值sum
        state.adminid=adminid;
     },
     setusername(state,username){ //同上，这里面的参数除了state之外还传了需要增加的值sum
        state.username=username;
     },
    newRoleid(state,roleid){ //同上，这里面的参数除了state之外还传了需要增加的值sum
        state.role_id=roleid;
     },
    newRolename(state,rolename){ //同上，这里面的参数除了state之外还传了需要增加的值sum
        state.role_name=rolename;
     },
    newMobilepwd(state,mobilepwd){ //同上，这里面的参数除了state之外还传了需要增加的值sum
        state.mobilepwd=mobilepwd;
     },
     setEnterpriseName(state,enterpriseName){
       state.enterpriseName=enterpriseName;
     },
     setUtypeid(state,utypeid){
       state.utypeid=utypeid;
     },
     setMiniUsername(state,miniUsername){
       state.miniUsername=miniUsername;
     },
     setAvatars(state,avatars){
       state.avatars=avatars;
     },
     setLastLoginTime(state,lastLoginTime){
       state.lastLoginTime=lastLoginTime;
     },
};
 const store = new Vuex.Store({
       state,
       getters,
       mutations,
       plugins: [createPersistedState({
             storage: window.sessionStorage
         })]
});
export default store;



// WEBPACK FOOTER //
// ./src/utils/store.js